(function ($, Cobalt, undefined) {
    Cobalt.Comment = {
        anchorScrollHeight: 35,
        priority: 2,
        commentCreatedFunctions: [],
        commentSelector: ".j-comment",
        dependentScripts: function() {
            return [{ dependency: Cobalt.TinyMCE, name: "Cobalt.TinyMCE"},{ dependency: Cobalt.Warning, name: "Cobalt.Warning" }];
        },
        onCommentCreated: function (functionToExecute) {
            Cobalt.Comment.commentCreatedFunctions.push(functionToExecute);
        },
        commentCreated: function ($newComment, $form, data) {
            for (var i = 0; i < Cobalt.Comment.commentCreatedFunctions.length; i++) {
                Cobalt.Comment.commentCreatedFunctions[i]($newComment, $form, data);
            }
        },
        initialize: function () {

            // Comment Forms
            Cobalt.runOnHtmlInsert(function ($parent) {

                $parent.find("form.comment-form").each(bindCommentForm);

                // Set the pre-processed comment data (used for quoting)
                $parent.find("div.j-comment").each(function () {
                    var $comment = $(this);
                    var $commentBody = $comment.find(".j-comment-body");
                    $comment.data("preprocessedBody", $commentBody.html());
                    handleRevisions($comment);
                });

                handleDeleteForm();
                Cobalt.Warning.handleWarnForm(Cobalt.Comment.warningSuccess);
                Cobalt.Comment.absolutifyLinks();
            });

            // Edit Comment
            $(".comment .user-action-edit a").live("click", handleEditClick);

            // Quote Comment
            $(".comment .user-action-quote a").live("click", handleQuoteClick);
            handleMultiQuote();

            // Reply to Comment
            $('.comment .user-action-reply a').live("click", handleReplyClick);

            // autoCollapse any deleted/spam comments in a forum (and not in an article)
            $(".p-forum .comment-spam > .expandable").hide();
            $(".p-forum .comment-deleted > .expandable").hide();
            $(".p-forum .comment-mute-banned > .expandable").hide();
            $(".p-forum .comment-deleted-with-note > .expandable").hide();

            handleShareLink();
            handleUserActions();
            handleSpamPost();
            handleSpamSignaturePost();
            handleUnDeletePost();
            handleMoveForm();
            Cobalt.MultiFileUpload.addAttachmentPadding();

            $("button#field-preview-submit").click(function () {
                var previewButton = $(this);
                previewButton.find("span").text("Cancel Preview");
                previewButton.click(function (e) {
                    e.preventDefault();
                    $("div#comment-preview").remove();
                    $(this).find("span").text("Preview");
                    $(this).unbind('click');
                });
            });

            // When our page loads, check to see if it contains and anchor
            anchorScroll(window.location.hash);
        },
        warningSuccess: function(result, form) {
            // check to see if the thread was deleted
            // and if so, reload the page to display the deleted banner
            // if we really wanted to, we could rewrite later to embed those messages in data tags and handle it client side
            if (result.ThreadDeleted) {
                location.reload(true);
            }

            // the thread was not deleted, just update the single comment view
            var $comment = $(".j-comment[data-id='" + form.data("id") + "']");
            if ($comment.length > 0) {
                updateCommentView($comment);
            } else {
                location.reload(true);
            }
        },
        absolutifyLinks: function() {
            //foreach comment

            // TODO: for now we will assume that we support relative urls if there are no options available
            // we should refactor this so that the options per site are aavailable even if tinymce hasn't been initialized yet
            // in the case of an anon user it won't be initialized since they can't comment.
            if (Cobalt.TinyMCE.options.relative_urls === false)
            {
                $(Cobalt.Comment.commentSelector).each(function() {
                    //foreach comment body (we don't assume more than one, but in case...)
                    $(this).find(".p-comment-content").each(function() {
                        //foreach a tag
                        $(this).find('a').each(function() {
                            var href = $(this).attr("href");

                            //if the href doesn't have http:// or https:// or # and that it's not already a valid relative url.
                            if (href !== undefined && href.indexOf('http://') !== 0
                                && href.indexOf('https://') !== 0 && href.indexOf("/") !== 0
                                && href.indexOf('#') !== 0) {
                                //append it!
                                $(this).attr('href', 'http://' + $(this).attr('href'));
                            }
                        });
                    });
                });
            }
        }
    };

    function resetForm(form) {

        // Reset the parent comment
        form.find("#field-parent-comment").val("");
        // Hide the reply to
        form.find(".in-reply-to").hide();

        // Reset the form
        form[0].reset();

        // Look for an attachment form
        form.find(".j-attachments").hide();
        form.find("ul.j-attachments-list").empty();

        if (form.hasClass("j-comment-reply-form") || form.hasClass("j-comment-edit-form")) {
            var markupType = form.find(".j-markup-type").val();
            if (markupType == "1" || markupType == "3") { // wsiwyg or bbcode
                Cobalt.TinyMCE.removeEditor(form);
            }
            form.parent().remove();
        }

        resetReCaptchas();
    }

    function emptyInReplyTo($inReplyTo) {
        $inReplyTo = $inReplyTo || $('.comment-form').find('.in-reply-to');

        $inReplyTo
            .hide()
            .find('a.link')
            .attr('href', '#')
            .text('');
    };

    // Comment Form Bindings
    function bindCommentForm() {
        var $form = $(this);
        if ($form.hasClass("j-comment-no-bind")) {
            return;
        }

        $form.bind('form-pre-serialize', function (e) {
            Cobalt.TinyMCE.saveEditorInForm($form);
        });

        var $formFooter = $form.find(".form-footer");

        var savedContent = $.cookie("Cobalt.Comment.LastSavedContent");
        var savedType = $.cookie("Cobalt.Comment.LastSavedContentType");
        if (savedContent != "" && savedContent != null) {
            $formFooter.append($("<button title='" + L.Global.Forums.RestoreContentDescription() + "' type='button' class='tip button'></button>")
                .click(function () { if (savedType == "markup") { $form.find("#field-body").val(savedContent); } else { $form.find("#field-body-wysiwyg").val(savedContent); } })
                .append($("<span>" + L.Global.Common.RestoreContent() + "</span>")));

            Cobalt.triggerHtmlInsert($formFooter);

        }

        var warningMessage = "You appear to have unsaved changes. Any unsaved changes will be lost if you leave this page.";


        $(window).on("beforeunload", function () {

            if ($form.data("_submitClicked")) {
                return null;
            }

            $form.data("_submitClicked", false);
            var showWarning = false;

            $form.find('input[type=text]').each(function () {
                if (this.value != this.defaultValue) {
                    $.log("Found change!");
                    $.log(this);
                    showWarning = true;
                }
            });

            $form.find('textarea:not(.j-wysiwyg-editor)').each(function () {
                if (this.value != this.defaultValue && !($(this).hasClass("j-wysiwyg-editor"))) {
                    $.log("Found change!");
                    $.log(this);
                    showWarning = true;
                }
            });

            if (window.tinymce !== undefined) {
                var mceInstance = window.tinymce.EditorManager.activeEditor;
            }

            if (mceInstance != null && mceInstance.isDirty()) {
                $.log("Found TinyMCE Change!");
                $.log(mceInstance);
                $.log(mceInstance.isDirty);
                showWarning = true;
            }

            if (showWarning) {
                return warningMessage;
            }
        });



        $form.find('button[type=submit]').on('click', function () {
            $form.data("_submitClicked", true);
        });

        var $module = $form.find("#reply");
        var maskTimeout;
        $form.ajaxForm(
        {
            beforeSubmit: function () {
                $form.mask();
                maskTimeout = setTimeout(function () { $module.form(); }, 10000);
                var markupText = $form.find("#field-body").val();
                if (markupText != "") {
                    $.cookie("Cobalt.Comment.LastSavedContent", markupText);
                    $.cookie("Cobalt.Comment.LastSavedContentType", "markup");
                }
                else {
                    $.cookie("Cobalt.Comment.LastSavedContent", $form.find("#field-body-wysiwyg").val());
                    $.cookie("Cobalt.Comment.LastSavedContentType", "wysiwyg");
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                $form.unmask();
                clearTimeout(maskTimeout);
            },
            success: function (data, textStatus, xhr) {
                $.cookie("Cobalt.Comment.LastSavedContent", "");
                clearTimeout(maskTimeout);

                var $listing = $("ul.j-comment-listing:visible");

                var previewID = $form.attr("data-preview-id") || "comment-preview";
                var $preview = $("#" + previewID);

                //// if this is a preview of an existing comment, don't use the global preview
                //// there will be one that was appended directly under the comment
                if (data.commentId) {
                    // find the comment-specific preview
                    $preview = $listing.find("div[data-preview-comment-id=" + data.commentId + "]");
                }


                switch (data.result) {
                    case "AjaxRedirect": break;
                    case "preview":
                        // clear out any existing comment previews
                        $("div[data-preview-comment-id]").empty();
                        var html = data.preview;
                        if ($preview.length == 0) {
                            if (data.commentId) {// edit comment preview
                                // find the comment
                                var $comment = $listing.find("div[data-id=" + data.commentId + "]");
                                // add the comment-specific preview container immediately after the comment
                                $preview = $("<div>").attr("data-preview-comment-id", data.commentId).addClass("module comment-preview");
                                $comment.after($preview);
                            } else { // add comment/pm preview
                                var placeholder = $form;
                                placeholder.before($("<div>").attr("id", previewID));

                                var previewButton = $("button#field-preview-submit");
                                previewButton.find("span").text("Cancel Preview");
                                previewButton.click(function (e) {
                                    e.preventDefault();
                                    $(this).parents("div.j-comment-form-container").find("div#" + previewID.toString()).remove();
                                    $(this).find("span").text("Preview");
                                    $(this).unbind('click');
                                });

                                $preview = $("#" + previewID);
                            }
                        }
                        $preview.html(html);
                        $form.unmask();
                        Cobalt.triggerHtmlInsert($preview);
                        $preview[0].scrollIntoView();

                        resetReCaptchas();

                        break;
                    case "success":
                        // clear out any existing comment previews
                        $("div[data-preview-comment-id]").empty();

                        // clear out the main preview, if one exists
                        if ($preview.length > 0) {
                            $preview.empty();
                        }

                        if (data.returnUrl !== "" && typeof data.returnUrl !== "undefined") {
                            document.location = data.returnUrl;
                        }

                        var $newComment = $(data.html);
                        Cobalt.triggerHtmlInsert($newComment);

                        // Remove the no-results message, if one exists
                        $("ul.j-comment-listing:visible > li.no-results").remove();

                        if (data.newForumTitle) { // user earned a new forum title with this comment
                            var authorId = $newComment.find('.j-comment').data('author-id');
                            var $authorComments = $('.j-comment').filter(function () {
                                return $(this).data('author-id') === authorId;
                            });
                            $authorComments.find(".p-comment-statitem.forum-title").text(data.newForumTitle);
                        }

                        if ($form.hasClass("j-comment-edit-form")) {
                            var $existingComment = $form.parents("div.j-comment");
                            $existingComment.find("div.j-comment-content").html($newComment.find("div.j-comment-content").html());

                            resetForm($form);
                            Cobalt.triggerHtmlInsert($existingComment);
                            handleRevisions($existingComment);
                            $form.unmask();
                        }
                        else {

                            resetForm($form);
                            // Determine where to append this to
                            $newComment.css('visibility', 'hidden');

                            var $parentComment = null;
                            if (data.parentCommentID) // Nested
                            {
                                // See if there are any existing replies to this:
                                if (data.childOrderReversed) {
                                    $parentComment = $listing.find("div[data-parent-comment=" + data.parentCommentID + "]").last().parent();
                                }

                                // If not, find the regular parent
                                if ($parentComment == null || $parentComment.length == 0) {
                                    $parentComment = $listing.find("div[data-id=" + data.parentCommentID + "]").parent();
                                }
                            }

                            if ($parentComment != null && $parentComment.length > 0) // Nested
                            {
                                $parentComment.after($newComment);
                            }
                            else // Normal
                            {
                                var sortMethod = $listing.attr("data-sort-method");
                                var append = true;

                                if (sortMethod == "wilson-score") {
                                    if (!data.orderDescending) {
                                        append = false;
                                    }
                                }
                                else {
                                    if (sortMethod != "date-created") {
                                    }
                                    if (data.orderDescending) {
                                        append = false;
                                    }
                                }

                                if (append) {
                                    if (data.mergedIntoPreviousComment) {
                                        $listing.children("li:last").remove();
                                    }
                                    $listing.append($newComment);
                                } else {
                                    if (data.mergedIntoPreviousComment) {
                                        $listing.children("li:first").remove();
                                    }
                                    $listing.prepend($newComment);
                                }

                            }

                            var newCommentOffset = $newComment.offset();
                            var newScrollTop = newCommentOffset.top + ($newComment.height() / 2) - ($(window).height() / 2);
                            if (newScrollTop < 0) {
                                newScrollTop = 0;
                            }

                            var st = (document.documentElement.scrollTop || document.body.scrollTop);
                            var ot = newCommentOffset.top;
                            var wh = (window.innerHeight && window.innerHeight < $(window).height()) ? window.innerHeight : $(window).height();

                            var isAlreadyVisible = ot > st && ($newComment.height() + ot) < (st + wh);
                            $newComment.hide();
                            $newComment.css('visibility', 'visible');

                            $("body,html,document").animate({ scrollTop: newScrollTop }, 500, function () {
                                $newComment.fadeIn(500);
                                $form.unmask();
                            });
                            Cobalt.Comment.commentCreated($newComment, $form, data);
                            Cobalt.UI.bindSpoilers();
                        }

                        break;
                    case "invalid":
                        $form.unmask();
                        Cobalt.Forms.displayErrors($form, data.errors);
                        break;
                    default:
                        $form.unmask();
                        throw "Unknown data result from comment form: " + data.result.toString();
                }
                Cobalt.Comment.absolutifyLinks();
            },
            dataType: "json"
        });

        $form.find(".close").click(function () {
            $form.find('#field-parent-comment').val('');
            emptyInReplyTo();
        });
    }

    // Handle Edit Button Clicks
    function handleEditClick(e) {
        e.preventDefault();
        var $comment = $(this).closest('.j-comment');
        var $existingForm = $comment.find(".j-comment-editor");
        if ($existingForm.length <= 0) {
            var $content = $comment.find(".forum-post-body");
            var $contentContainer = $comment.find(".forum-post-body-container");
            var $contentWrapper = $comment.find(".forum-post-body-content");

            if ($content.length != 1) {
                throw "Cannot find body content to replace";
            }

            var url = $(this).attr("href").toString();
            $.ajax({
                url: url,
                success: function (data) {
                    $contentWrapper.hide();
                    var $editForm = $("<div/>").addClass("p-comment-editor").addClass("j-comment-editor");
                    $editForm.html(data);

                    $editForm.find(".j-cancel-button").click(function (e) {
                        e.preventDefault();
                        Cobalt.TinyMCE.removeEditor($editForm);
                        $editForm.remove();
                        $contentWrapper.show();
                    });

                    $contentContainer.append($editForm);
                    $editForm[0].scrollIntoView();
                    Cobalt.triggerHtmlInsert($contentContainer);
                },
                dataType: "html",
                type: "GET"
            });
        }
        return false;
    }

    function stripHtmltags(html) {
        var regex = /<\/?[^>]+>/gi;
        return html.replace(regex, '');
    }

    function createQuote(commentForm, commentID) {
        var textAreaBody = commentForm.find("#field-body");
        if (textAreaBody.length === 0) { textAreaBody = commentForm.find(".j-markup-editor"); } //fallback for markitup
        var destinationMarkupType = Cobalt.Markup.currentSelectedMarkup(commentForm);

        jQuery.ajax({
            url: '/comments/' + commentID + '/quote',
            data: { destinationType: destinationMarkupType },
            success: function (data) {
                if (data.body) {
                    createQuotePlaceholder(commentForm, data.authorName, data.authorLink, data.postLink, data.body, destinationMarkupType, textAreaBody, data.quoteMarkup);
                }
            },
            async: false
        });
    }

    function addNewLineAfterQuote(quoteContent) {
        return quoteContent + "<p></p>";
    }

    function createQuotePlaceholder(commentForm, authorName, authorLink, postLink, postBody, markupType, textAreaBody, quoteMarkup) {
        postBody = '<div class="quote-body">' + postBody + '</div>';
        var postText = postBody;
        var quoteLink = $('<a>').attr('href', postLink).addClass('go-next').text('>>');
        var quoteHeader = $('<div>').addClass("quote-source").html(L.Global.Common.QuoteFrom("<a class=\"quote-author\" href=\"" + authorLink + "\">" + authorName + "</a> ")).append(quoteLink);
        var quoteBody = $("<blockquote>").addClass("source-quote").append(quoteHeader).append(postBody);
        var quoteHtml = $("<div>").append(quoteBody).html();
        var curentTextBodyVal = textAreaBody.val() || textAreaBody.text();

        // set quote depth from preference
        var boolNestQuotes = $.cookie("Preferences.NestQuotes");
        var nestQuotesSite = Cobalt.Constants.NestedQuotePreference;
        var maxQuoteDepth = Cobalt.User.MaxQuoteDepth;
        if (nestQuotesSite === 2 || (nestQuotesSite === 0 && boolNestQuotes === 'false')) {
            maxQuoteDepth = 1;
        }

        switch (markupType) {
            case 1:
                // WYSIWYG
                quoteHtml = limitQuotes(quoteHtml, maxQuoteDepth);

                Cobalt.TinyMCE.getEditorFromForm(commentForm, function($editor) {
                    var $content = appendQuoteOntoExistingContent($editor, quoteHtml);
                    $editor.setContent($content);
                    Cobalt.TinyMCE.focusEditor($editor);
                });

                break;
            case 3:
                // BBcode
                quoteHtml = limitBBCodeQuotes(quoteHtml, maxQuoteDepth);

                Cobalt.TinyMCE.getEditorFromForm(commentForm, function ($editor) {
                    $($editor.editorContainer).attr("insertHtmlQuote", (quoteMarkup == 1 || quoteMarkup == 2) ? "true" : "false");
                    var $content = appendQuoteOntoExistingContent($editor, quoteHtml);
                    $content = $content.replace("[/quote]<blockquote", "[/quote]<blockquote");
                    $editor.setContent($content);
                    $($editor.editorContainer).removeAttr("insertHtmlQuote");
                    Cobalt.TinyMCE.focusEditor($editor);
                });

                break;
            case 4:
                // Creole
            case 6:
                // Raw Html
                textAreaBody.val(curentTextBodyVal + quoteHtml).focus();
                break;
            case 2:
                // Plain text
                var newText = L.Global.Common.QuoteFrom(authorName) + "\n" + stripHtmltags(postText).replace(/(&nbsp;)+/gi, " ");
                newText = newText.split("\n").join("\n\t");
                textAreaBody.val(curentTextBodyVal + newText);
                break;
            case 8:
                // Standard BBCode
                var quote = "[quote from=\"{0} &raquo;\" url=\"{1}\"]{2}[/quote]".format(authorName, postLink, stripHtmltags(postText).replace(/(&nbsp;)+/gi, " "));

                // set quote depth
                quote = limitBBCodeQuotes(quote, maxQuoteDepth); textAreaBody.val(curentTextBodyVal + quote);
                textAreaBody.val(curentTextBodyVal + quote);
                betterFocus(textAreaBody);
                break;
            default:
                break;
        }
    }

    function appendQuoteOntoExistingContent($editor, quoteHtml) {
        // TinyMCE will unescape sensitive markup that we have escaped if we do not pass in this raw format.
        var options = { format: "html" };
        var content = $editor.getContent(options) + quoteHtml;
        return addNewLineAfterQuote(content);
    }

    // focuses on element and sends cursor at the end
    function betterFocus(body) {
        body.focus();
        var tmpStr = body.val();
        body.val('');
        body.val(tmpStr);
    }

    // limits quote depth on bbcode
    function limitBBCodeQuotes(html, maxDepth) {
        html = html.split(/\[quote/).join('<blockquote>[quote');
        html = html.split(/\[\/quote\]/).join('[/quote]</blockquote>');
        html = limitQuotes(html, maxDepth);
        html = html.split('<blockquote>[quote').join('[quote');
        html = html.split('<blockquote class="source-quote">[quote').join('[quote');
        html = html.split('[/quote]</blockquote>').join('[/quote]');
        // finally, if there ends up being any quotes smashed together, add a new line between them (MTGS-42)
        html = html.split("[quote][/quote]").join("[quote]\r\n[/quote]");
        return html;
    }

    // limits quote depth on wysiwyg html
    function limitQuotes(html, maxDepth) {
        var depthSelector = '';
        if (maxDepth > 0) {
            depthSelector = 'blockquote';
        }
        for (var i = 0; i < maxDepth - 1; i++) {
            depthSelector += ' > blockquote';
        }
        html = $(html);
        html.find(depthSelector).remove();
        return '<blockquote class="source-quote">' + html.html() + '</blockquote>';
    }

    // Handle Quote Button Clicks
    function handleQuoteClick(e) {
        e.preventDefault();

        // Get or create the associated reply form
        var $comment = $(this).closest('.comment');
        var commentID = $comment.attr('data-id');
        var $replyForm = $(".j-comment-form-container form.j-comment-form");

        if ($replyForm.length > 0) {
            createQuote($replyForm, commentID, false);
            $("body").animate({ scrollTop: $replyForm.offset().top }, 500);
        }
        else {
            createReplyForm($comment, function (commentForm) { createQuote(commentForm, commentID, false); });
        }
    }

    function createReplyForm(parentComment, afterLoadFn) {
        var $li = parentComment.parent();
        var $ul = $li.parent();
        var parentCommentID = getCommentParentID(parentComment);

        // If another reply form exists (which is not the intended one) remove it.
        var $otherFormContainer = $ul.find(".j-comment-form-container");
        var $otherFormParent = $otherFormContainer.parent();

        if ($otherFormParent.length == 1 && $otherFormParent[0] != $li[0]) {
            Cobalt.TinyMCE.removeEditor($otherFormContainer);
            $otherFormContainer.remove();
        }

        // Find an existing form for this reply
        var $existingFormContainer = $li.find(".j-comment-form-container");
        if ($existingFormContainer.length > 0) {
            var $existingForm = $existingFormContainer.find("form.j-comment-reply-form").first();
            resetForm($existingForm);
            return;
        }

        var getUrl = "/comments/create-" + parentComment.attr("data-parent-type-id") + "-" + parentComment.attr("data-parent-id") + "/form";
        $.get(getUrl, function (data) {

            // Reply Form Container
            var $replyFormContainer = $(data.html).find(".j-comment-form-container");
            $replyFormContainer.addClass("p-comment-reply-form");

            // Reply Form
            var $replyForm = $replyFormContainer.find("form").first();
            $replyForm.removeClass("j-comment-form").addClass("j-comment-reply-form");
            $replyForm.attr("data-parent-comment-id", parentCommentID);
            $replyForm.attr("data-preview-id", parentCommentID);
            $replyForm.find("#field-reply-comment").val(getReplyCommentID(parentComment));
            $replyForm.find("#field-parent-comment").val(parentCommentID);
            $replyForm.css("visibility", "hidden");
            // Attachment Form
            $replyFormContainer.find(".j-attachments").attr("id", "j-attachments-reply-" + parentCommentID);
            var buttonElement = $replyFormContainer.find(".j-upload-attachment-0");
            buttonElement.addClass("j-upload-attachment-reply-" + parentCommentID).removeClass("j-upload-attachment-0");
            $replyFormContainer.find(".j-attachments-form input.j-multi-file-upload").attr("data-attach-to-element-id", "j-attachments-reply-" + parentCommentID);
            $replyFormContainer.find(".j-attachments-form input.j-multi-file-upload").attr("data-button-element-id", ".j-upload-attachment-reply-" + parentCommentID);

            // Append the Reply Form Container
            parentComment.after($replyFormContainer);
            //$replyForm.find("textarea").first().removeAttr("id");
            var replyEditorId = $replyForm.find("textarea").first().attr("id") + parentCommentID;
            $replyForm.find("textarea").first().attr("id", replyEditorId);
            Cobalt.triggerHtmlInsert($replyForm.parent());
            $replyForm.hide();
            $replyForm.css("visibility", "visible");

            // Fade in the reply form
            $replyForm.fadeIn(500);
            var markupType = $replyForm.find(".j-markup-type").val();
            if (markupType == "1" || markupType == "3") {
                Cobalt.TinyMCE.getEditorFromForm($replyForm, function (editor) {
                    editor.focus();
                });
            }

            if (afterLoadFn != null) {
                afterLoadFn($replyForm);
            }

        });
    }

    function handleReplyClick(e) {
        e.preventDefault();
        var $comment = $(this).closest('.comment');
        createReplyForm($comment);
    }

    function getReplyCommentID(replyComment) {
        return replyComment.attr("data-id");
    }

    function getCommentParentID(parentComment) {
        var $form = $("form.j-comment-form");
        var maxCommentDepth = parseInt($form.data("max-comment-depth"), null);
        var proposedDepth = parseInt(parentComment.attr("data-depth"), null) + 1;
        if (proposedDepth > maxCommentDepth) {
            return parentComment.attr("data-parent-comment");
        }
        else {
            return parentComment.attr("data-id");
        }
    }

    function handleDeleteForm() {
        var messageField = $(".j-comment-delete-form #form-field-message");
        var showMessageField = $(".j-comment-delete-form #field-show-message");
        messageField.css("display", "none");
        showMessageField.change(function () {
            if (showMessageField.is(':checked')) {
                messageField.css("display", "block");
            }
            else {
                messageField.css("display", "none");
            }
        });

        var $form = $(".ajax-delete");

        $form.ajaxForm({
            beforeSubmit: function () {
                $form.find(':submit').attr('disabled', 'disabled');
            },
            success: function (result) {
                if (result.Status === undefined || (result.Status !== undefined && result.Status != "invalid")) {
                    // check to see if the delete resulted in a thread delete
                    // and if so, reload the page to display the deleted banner
                    // if we really wanted to, we rewrite later to embed those messages in data tags and handle it client side
                    if (result.ThreadDeleted) {
                        location.reload(true);
                    }

                    $(".ui-dialog-titlebar-close").click();

                    // find the comment element and mark it as deleted
                    var $comment = $(".j-comment[data-id='" + $form.data("id") + "']");
                    if ($comment.length > 0) {
                        //swap the existing comment with the new view and rebind
                        var $commentListItem = $comment.parent();
                        $commentListItem.replaceWith(result.View);
                        Cobalt.runOnHtmlInsert(function () {
                            handleUnDeletePost();
                        });

                        triggerHtmlInsertOnContent();
                    }

                } else {
                    $form.find(":submit").removeAttr("disabled");
                    Cobalt.Forms.displayErrors($form, result.Errors);
                }
            }
        });
    }

    function triggerHtmlInsertOnContent() {
        Cobalt.triggerHtmlInsert($("#content"));
    }

    function handleShareLink() {

        // Close modal when clicking off it
        if ($("#comments").length > 0) {
            $("#comments").bind("hide-share-modal", function () {
                $("body").on("click", function (e) {
                    var target = $(e.target);
                    if (!target.hasClass("isOpen")) {
                        var shareModal = $("#share-link-comment").parent();
                        if (shareModal.is(":visible") && shareModal.find(target).length === 0) {
                            shareModal.find("a.ui-dialog-titlebar-close").click();
                        }
                    }
                });
            });
        }

        $("#comments .comment .post-index > a[data-link-prompt=true]").each(function () {
            var $that = $(this);
            var clickContent = null;

            //if mobile in enabled used the mobile shar target as the click event to pop up the share module
            if ($('body').width() <= 640 || Cobalt.detectIsOnMobile()) {
                clickContent = $that.parents(".j-comment").find(".mobile-share-target");
            } else {
                clickContent = $that;
            }

            clickContent.on("click", { link: $that }, function (e) {

            e.preventDefault();
            if ($("#share-link-comment").length > 0) {
                $("#share-link-comment").parent().find("a.ui-dialog-titlebar-close").click();
            }

            var $link = e.data.link;
            var $target = $(this);

            if ($target.hasClass("isOpen")) {
                return;
            }

            $target.addClass("isOpen");

            var html = "<div id=\"share-link-comment\"><input type=\"text\" value=\"{0}\" class=\"full-width\" /></div>";

            var dataUrl = $link.prop('href').toString();
            var fullUrl = dataUrl;
            if (fullUrl.indexOf("http") === -1) {
                fullUrl = location.protocol + "//" + location.host + "/" + dataUrl;
            }

            html = html.format(fullUrl);
            var $shareDialog = $(html);

            Cobalt.triggerHtmlInsert($shareDialog);

            $shareDialog.dialog(
            {
                title: "Share Post",
                modal: false,
                position: [e.clientX - 295, e.clientY + 25],
                height: 100,
                dialogClass: "share-post",
                close: function (event, ui) {
                    $shareDialog.dialog("destroy");
                    $shareDialog.remove();
                    $target.removeClass("isOpen");
                }
            });

            $("#share-link-comment input").select();
            $("#comments").trigger("hide-share-modal");
            });
        });
    }

    var commentRevisions = [];
    function Revision(commentID, revisionID, body, processedBody, revisionStatus, commentStatus) {
        this.commentID = commentID;
        this.revisionID = revisionID;
        this.body = body;
        this.processedBody = processedBody;
        this.revisionStatus = revisionStatus;
        this.commentStatus = commentStatus;
    }
    function getRevision(commentID, revisionID) {
        if (commentRevisions.length > 0) {
            return $.grep(commentRevisions, function (r) { return r.commentID === commentID && r.revisionID === revisionID; })[0];
        }
    }

    function handleRevisions($comment) {
        var $commentRevisions = $(".j-comment-revisions");
        if ($commentRevisions.length > 0) {

            $comment.on("click", ".j-comment-revisions", function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();

                var isVisible = $comment.find(".j-comment-revisions-history").toggle().is(":visible");

                if (!isVisible) {
                    if ($comment.find(".j-comment-revisions-select option").length > 0) {
                        $comment.find(".j-comment-revisions-select option:eq(0)").attr('selected', 'selected').change();
                    }
                    $(this).removeClass("selected");
                } else {
                    $(this).addClass("selected");
                }
                //get revisions
                var $selectRevisions = $comment.find(".j-comment-revisions-select");
                if ($selectRevisions.find("option").length <= 0) {
                    $comment.mask();
                    $.get(Cobalt.Routes.Instance.CommentGetCommentRevisions($comment.data("id")), function (data) {
                        if (data) {
                            if (data.revisions && data.revisions.length > 0) {
                                data.revisions = $.parseJSON(data.revisions);
                                $selectRevisions.append("<option value='0'>-</option>");
                                var currentMarkup = $comment.find(".j-comment-body").html();
                                commentRevisions.push(new Revision($comment.data("id"), 0, currentMarkup, currentMarkup, data.revisionStatus));
                                for (var i = 0; i < data.revisions.length; i++) {
                                    if (i === 0) {
                                        $comment.commentStatus = data.revisions[0].commentStatus;
                                    }
                                    var rev = data.revisions[i];
                                    // not using Cobalt.NiceDates here because we can just quickly convert
                                    // to a local date and time before injecting into the option
                                    // and all we really care about is that this reflects the local date/time
                                    var date = Cobalt.newDate(rev.epoch * 1000); // convert .NET time to Js time and get localized time from newDate
                                    var localizedDate = date.toLocaleDateString() + " " + date.toLocaleTimeString();
                                    var $option = $("<option value='" + rev.revisionNumber + "'>#" + rev.revisionNumber
                                        + " " + localizedDate + " by: " + rev.author
                                        + (rev.revisionStatus !== undefined
                                            ? "(" + rev.revisionStatus + ")"
                                            : "") + "</option>").addClass("localized-date-string");
                                    $selectRevisions.append($option);
                                }
                                Cobalt.triggerHtmlInsert($selectRevisions);
                            }
                        }
                        $comment.unmask();
                    });
                }
            });

            $comment.on("change", ".j-comment-revisions-select", function () {
                //get rendered version
                var $selectedOption = $(this).find("option:selected");

                var setBody = function (processedBody) {
                    $comment.find(".j-comment-body").empty().append(processedBody);
                    Cobalt.UI.bindSpoilers();
                };
                var setEditor = function (body) {
                    if ($comment.find(".j-comment-editor").length > 0) {
                        if (window.tinymce && window.tinymce.activeEditor && $comment.find(".markItUpEditor").length === 0) {
                            window.tinymce.activeEditor.setContent(body);
                        } else {
                            $comment.find(".j-markup-editor").text(body);
                        }
                    }
                };
                var setStatus = function (newStatus) {
                    if (newStatus !== undefined) {
                        $comment.removeClass("comment-" + $comment.currentStatus).addClass("comment-" + newStatus);
                        $comment.currentStatus = newStatus;
                    }
                };

                if ($selectedOption.index() === 0) { //for current
                    var currentMarkup = getRevision($comment.data("id"), 0);
                    if (currentMarkup) {
                        setBody(currentMarkup.processedBody);
                        setEditor(currentMarkup.body);
                    }
                    return;
                }

                var commentID = $comment.data("id");
                var revisionNumber = $selectedOption.val();
                var tryGetRevision = getRevision(commentID, revisionNumber);
                if (!tryGetRevision) {
                    $comment.mask();
                    $.get(Cobalt.Routes.Instance.CommentGetCommentRevision(commentID, revisionNumber), function (data) {
                        if (data) {
                            if (data.status === "success") {
                                commentRevisions.push(new Revision(commentID, revisionNumber, data.body, data.processedBody, data.revisionStatus));
                                setBody(data.processedBody);
                                setEditor(data.body);
                                setStatus(data.revisionStatus);
                            }
                        }
                        $comment.unmask();
                    });
                }
                else {
                    setBody(tryGetRevision.processedBody);
                    setEditor(tryGetRevision.body);
                    setStatus(tryGetRevision.revisionStatus);
                }
            });

            $comment.on("click", ".j-comment-revisions-rollback", function (e) {
                e.stopImmediatePropagation();

                if ($comment.find(".j-comment-revisions-select option:selected").prop("index") === 0) {
                    return;
                }

                if (confirm("Are you sure you want to rollback to this revision?")) {

                    var commentID = $comment.data("id");
                    var revisionNumber = $comment.find(".j-comment-revisions-select option:selected").val();
                    var requestVerificationToken = $.cookie("RequestVerificationToken");
                    if (requestVerificationToken) {
                        $.post(Cobalt.Routes.Instance.CommentRevisionRollback(commentID, revisionNumber),{'request-verification-token': requestVerificationToken}, function (data) {
                            $comment.find(".j-comment-revisions-history").toggle();
                        });
                    } else {
                        $.ajax({
                            url: "/refresh-request-verification-token",
                            type: 'POST',
                            dataType: 'json',
                            success: function () {
                                $.post(Cobalt.Routes.Instance.CommentRevisionRollback(commentID, revisionNumber), { 'request-verification-token':  $.cookie("RequestVerificationToken") }, function (data) {
                                    $comment.find(".j-comment-revisions-history").toggle();
                                });
                            }
                        });
                    }
                }
            });

            $comment.on("click", ".j-comment-revisions-cancel", function (e) {
                e.preventDefault();
                var commentRevisionsElement = $comment.find(".j-comment-revisions-history").toggle();
                var isVisible = commentRevisionsElement.is(":visible");

                if (!isVisible) {
                    if ($comment.find(".j-comment-revisions-select option").length > 0) {
                        $comment.find(".j-comment-revisions-select option:eq(0)").attr('selected', 'selected').change();
                    }
                    $(this).removeClass("selected");
                } else {
                    $(this).addClass("selected");
                }
            });
        }
    }

    // there is some duplication of code between handleSpamPost and
    // handleSpamSignaturePost. leaving for now as this behavior is being evaluated
    function handleSpamPost() {
        $("body").on("click", "div.j-comment-actions a.spam-post", function (e) {
            e.preventDefault();
            var $that = $(this);

            if ($that.hasClass('disabled') || $that.hasClass('loading')) {
                return;
            }

            var confirmMessage = $that.attr('data-confirm-message');
            var parentNodeSelector = $that.attr("data-parent-selector");

            if (!confirmMessage && $that.hasClass('confirm'))
                confirmMessage = 'Are you sure?';

            if (confirmMessage !== undefined && !confirm(confirmMessage))
                return;

            var href = $that.attr('href');
            var $form = $('<form>').attr('method', 'post').attr('action', href).hide();
            $that.parent().append($form);

            if (!$that.hasClass('silent')) {
                $that.addClass('loading');
            }

            Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                Cobalt.Forms.AjaxPostSubmit($that, token).done(function () {
                    if (parentNodeSelector !== undefined && parentNodeSelector !== "") {
                        var $parentNode = $this.parents(parentNodeSelector);
                        $parentNode.fadeOut(function () {
                            $parentNode.remove();
                        });
                    }

                    var $comment = $that.closest(".j-comment");
                    updateCommentView($comment);
                });
            });
        });
    }
    function handleSpamSignaturePost() {
        $("body").on("click", "div.j-comment-actions a.spam-sig-post", function (e) {
            e.preventDefault();
            var $that = $(this);

            if ($that.hasClass('disabled') || $that.hasClass('loading')) {
                return;
            }

            var confirmMessage = $that.attr('data-confirm-message');
            var parentNodeSelector = $that.attr("data-parent-selector");

            if (!confirmMessage && $that.hasClass('confirm'))
                confirmMessage = 'Are you sure?';

            if (confirmMessage !== undefined && !confirm(confirmMessage))
                return;

            var href = $that.attr('href');
            var $form = $('<form>').attr('method', 'post').attr('action', href).hide();
            $that.parent().append($form);

            if (!$that.hasClass('silent')) {
                $that.addClass('loading');
            }

            Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                Cobalt.Forms.AjaxPostSubmit($that, token).done(function () {
                    if (parentNodeSelector !== undefined && parentNodeSelector !== "") {
                        var $parentNode = $this.parents(parentNodeSelector);
                        $parentNode.fadeOut(function () {
                            $parentNode.remove();
                        });
                    }

                    var $comment = $that.closest(".j-comment");
                    updateCommentView($comment);
                });
            });

        });
    }

    function updateCommentView($comment) {
        ///<summary>Makes a call to "/comments/{commentId}/get-partial-view" to retrieve
        /// the refreshed partial view html for the given comment id and then updates the view.</summary>
        ///<param name="$comment" Type="jQuery Wrapper">The comment element to update</param>

        // get comment id from element
        var commentId = $comment.data("id");
        var url = "/comments/" + commentId + "/get-partial-view";
        $comment.mask();
        $.get(url, function(data) {
            // update the comment view
            $comment.parent().replaceWith(data.View);
            triggerHtmlInsertOnContent();
            $comment.unmask();
        });
        Cobalt.UI.bindSpoilers();
    }

    function handleUnDeletePost() {
        $("body").on("click", "div.j-comment-actions a.undelete-post", function (e) {
            e.preventDefault();
            var $that = $(this);

            if ($that.hasClass('disabled') || $that.hasClass('loading')) {
                return;
            }

            var confirmMessage = $that.attr('data-confirm-message');
            var parentNodeSelector = $that.attr("data-parent-selector");

            if (!confirmMessage)
                confirmMessage = 'Are you sure you want to undelete this comment?';

            if (confirmMessage !== undefined && !confirm(confirmMessage))
                return;

            var href = $that.attr('href');
            var $form = $('<form>').attr('method', 'post').attr('action', href).hide();
            $that.parent().append($form);

            if (!$that.hasClass('silent')) {
                $that.addClass('loading');
            }

            $form.ajaxSubmit(function (result) {

                // check to see if the undelete resulted in a thread UN-delete
                // and if so, reload the page to update the banner
                // if we really wanted to, we rewrite later to embed those messages in data tags and handle it client side
                if (result.ThreadUndeleted) {
                    location.reload(true);
                }

                $that.removeClass('loading');

                if (parentNodeSelector !== undefined && parentNodeSelector !== "") {
                    var $parentNode = $this.parents(parentNodeSelector);
                    $parentNode.fadeOut(function () {
                        $parentNode.remove();
                    });
                }

                // swap for the new  view and rebind
                var $comment = $that.closest(".j-comment");
                var $commentListItem = $comment.parent();
                $commentListItem.replaceWith(result.View);
                triggerHtmlInsertOnContent();
            });

        });
    }

    function handleMoveForm() {


        $("body").on("change", ".comment-move-form #field-choose-type input", function () {
            var form = $(".comment-move-form");

            var searchField = form.find("#form-field-search-specific-forums");
            var forumField = form.find("#form-field-forum");
            var titleField = form.find("#form-field-thread-title");
            var existingUrlField = form.find("#form-field-existing-thread-url");

            if ($(this).is(":checked")) {
                if ($(this).val() === "Move Post(s) to New Thread") {
                    searchField.show();
                    forumField.show();
                    titleField.show();
                    existingUrlField.hide();
                } else {
                    searchField.hide();
                    forumField.hide();
                    titleField.hide();
                    existingUrlField.show();
                }
            }
        });

    }

    function handleMultiQuote() {
        handleMultiQuoteReply();
        handleMultiQuoteClear();

        var multiQuoteCookieName = "Cobalt.Comment.MultiQuote";
        var $quoteContainer = $(".j-multi-quote-container");

        Cobalt.runOnHtmlInsert(function () {
            if ($("#comments").length > 0) {
                var cookie = $.cookie(multiQuoteCookieName);
                if (cookie) {
                    var parsedValue = parseMultiQuote(cookie);

                    var parentID = $("#comments").find(".j-comment:first").attr("data-parent-id");
                    if (parentID !== parsedValue.parentID) {
                        $.cookie(multiQuoteCookieName, null); //kill cookie, on new entity
                    } else {
                        $quoteContainer.find(".j-quote-number").text(parsedValue.commentIDs.length);
                        $quoteContainer.removeClass("hide");
                    }
                } else {
                    $quoteContainer.addClass("hide");
                }
            }
        });


        $("#comments").on("click", ".j-comment-multi-quote", function (e) {
            e.preventDefault();
            var $that = $(this);

            $that.toggleClass('multi-quote-selected');

            var $comment = $that.parents(".j-comment");
            var parentID = $comment.attr("data-parent-id");
            var commentID = $comment.attr("data-id");

            var cookie = $.cookie(multiQuoteCookieName);
            if (cookie) {
                var parsedValue = parseMultiQuote(cookie);
                if (parsedValue.parentID === parentID) {
                    if ($.inArray(commentID, parsedValue.commentIDs) > -1) { //remove
                        parsedValue.commentIDs.splice($.inArray(commentID, parsedValue.commentIDs), 1);
                    } else { //add
                        parsedValue.commentIDs.push(commentID);
                    }

                    $quoteContainer.find(".j-quote-number").text(parsedValue.commentIDs.length);
                    $.cookie(multiQuoteCookieName, parsedValue.parentID + "-" + (parsedValue.commentIDs.length > 0 ? parsedValue.commentIDs.join() : ""));
                    if (parsedValue.commentIDs.length <= 0) {
                        $quoteContainer.addClass("hide");
                        $that.removeClass('multi-quote-selected');
                    } else {
                        $quoteContainer.removeClass("hide");
                    }
                }
            } else {
                $.cookie(multiQuoteCookieName, parentID + "-" + commentID);
                $quoteContainer.find(".j-quote-number").text('1');
                $quoteContainer.removeClass("hide");
            }

        });
    }

    function parseMultiQuote(value) {
        var regex = /^(.*?)\-(.*?)$/g;

        var match = regex.exec(value);
        if (match) {
            return { parentID: match[1], commentIDs: match[2].split(',').clean() };
        } else {
            return { parentID: null, commentIDs: [] };
        }
    }

    function handleMultiQuoteReply() {
        $(".j-multi-quote-reply").on("click", function () {
            var multiQuoteCookieName = "Cobalt.Comment.MultiQuote";

            var $that = $(this);

            if ($that.is(":visible")) {
                var cookie = $.cookie(multiQuoteCookieName);
                if (cookie) {
                    var parsedValue = parseMultiQuote(cookie);

                    var $commentForm = $("#reply").find(".j-comment-form");

                    for (var i = 0; i < parsedValue.commentIDs.length; i++) {
                        createQuote($commentForm, parsedValue.commentIDs[i]);
                    }

                    $.cookie(multiQuoteCookieName, null); //kill cookie
                    $(".j-multi-quote-container").addClass("hide"); //hide the widget
                    window.location.hash = "#reply";    //move to #reply
                    $(".j-comment-multi-quote").removeClass('multi-quote-selected'); //multi-quote links should be unselected now
                }
            }
        });
    }

    function handleMultiQuoteClear() {
        $(".j-multi-quote-clear").on("click", function () {
            var multiQuoteCookieName = "Cobalt.Comment.MultiQuote";

            $.cookie(multiQuoteCookieName, null); //kill cookie
            $(".j-multi-quote-container").addClass("hide");
            $(".j-comment-multi-quote").removeClass('multi-quote-selected');
        });
    }

    // this anchors 50 pixels above a comment when linking or anchoring to it
    function anchorScroll(href) {
        if (!href) return;

        var fromTop = Cobalt.Comment.anchorScrollHeight;

        if (href.charAt(0) == "#") {
            try {
                var $target = $("div" + href);
            } catch(e) {
                return false;
            }

            if ($target.length) {
                $('html, body').animate({ scrollTop: $target.offset().top - fromTop });
                // check to make sure the location doesn't already match the current location
                if (window.location.hash !== href) {
                    // the current scroll location is not already in the path
                    // add it if we can
                    if (window.history && window.history.pushState) {
                        window.history.pushState({}, document.title, window.location.pathname + href);
                    }

                }
            }
        }
    }

    //Goes through a form and refreshes any reCpatchas
    function resetReCaptchas() {
        $("div.g-recaptcha").each(function() {
            grecaptcha.reset($(this).attr('widgetID'));
        });
    }

    function handleUserActions() {
        //foreach comment
        $(Cobalt.Comment.commentSelector).each(function() {
            var author = $(this).attr("data-surrogate-id");
            var userID = 0;
            if (!isNaN(Cobalt.User.userID)) {
                 userID = Cobalt.User.userID;
            }

            if (userID == author) {
                var ignoreCntrl = $(this).find(".j-user-ignore");
                if (ignoreCntrl.length > 0) {
                    ignoreCntrl.hide();
                }
                var followCnrl = $(this).find(".j-notification-sub");
                if (followCnrl.length > 0) {
                    followCnrl.parent().hide();
                }
            }

        });
    }


})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Comment.js